<template>
  <div class="pb100">
    <banner/>
    <crumbs/>
    <div class="container">
      <div class="listcontainer mt20 clearfix">
        <div class="leftcon fl">
          <type-screen
            modelType="pointsmall"
            :menu-id="this.$route.query.columnId"
            @typeObj="selectType"/>
          <ul class="ul-model5 clearfix mt20">
            <li v-for="(item, index) in List" :key="index">
              <router-link :to="'/pointsmalldetail?columnId=' + item.menuId + '&id=' + item.id">
                <div class="imgbox">
                  <img class="icon" v-if="item.detailUrl !== undefined && item.detailUrl !== ''" src="../../assets/common/icon/icon-video1.png" alt="">
                  <img class="imgtop" :src="getImage(item.image)" alt="">
                </div>
                <div class="txtbox">
                  <h2 class="textover">{{ item.name }}</h2>
                  <p class="date textover">{{ item.price }}积分</p>
                  <span class="more gradientGreenBlue mt10">立即兑换</span>
                </div>
              </router-link>
            </li>
          </ul>
          <nodata v-show="nodataflag"/>
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size="Param.limit"
            :pager-count="5"
            :current-page.sync="currentPage"
            layout="prev, pager, next"
            :total="listTotal"
            class="pagemodel1">
          </el-pagination>
        </div>
        <div class="rightcon fr">
          <creditrule/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getpointsmallList } from '@/api/pointsmall/index'
import crumbs from '@/components/crumbs/index'
import banner from '@/components/banner/index'
import typeScreen from '@/components/typescreen/index'
import nodata from '@/components/nodata/index'
import { timeFormat } from '@/utils/validate'
import { scrollAnimation } from '@/utils/index'
import creditrule from './creditrule'
export default {
  name: 'pointsmall',
  meta: {
    showHeader: true
  },
  components: {
    typeScreen,
    crumbs,
    nodata,
    banner,
    creditrule
  },
  data () {
    return {
      Param: {
        pageNum: 1,
        limit: 12,
        types: '',
        recommend: '',
        state: -1
      },
      currentPage: 1,
      nodataflag: false,
      List: [],
      listTotal: 0
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getTime (val) {
      return timeFormat(val, 'yymmdd').replace(/-/g, '/')
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    getList () {
      getpointsmallList(this.$route.query.columnId, this.Param).then((res) => {
        if (res.data.status === 0) {
          this.listTotal = res.data.totalSize
          if (this.listTotal === 0) {
            this.nodataflag = true
          } else {
            this.nodataflag = false
          }
          this.List = res.data.data
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 分页触发
    handleCurrentChange (val) {
      this.Param.pageNum = val
      const currentY = document.documentElement.scrollTop || document.body.scrollTop
      scrollAnimation(currentY, 0)
      this.getList()
    },
    /* 筛选条件 */
    selectType (obj) {
      this.Param.types = obj.customTypeId
      this.Param.pageNum = 1
      this.currentPage = 1
      this.getList()
    },
    detaillink (item) {
      this.$router.push({path: '/pointsmalldetail', query: {columnId: item.menuId, id: item.id}})
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .creditruledialog{
  .el-dialog__body{
    padding: 5px 25px 20px;
  }
}
.ul-model5{
  li{
    a{
      padding: 0;
      .txtbox{
        padding: 20px;
        text-align: center;
        h2{
          height: 28px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/pointsmall/list.vue